import { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useCustomer } from '@/context/CustomerContext';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

export default function CustomerLogin() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { login } = useCustomer();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login("0", formData.email, formData.password); // "0" is Main Store ID
            toast.success("Welcome back!");

            const params = new URLSearchParams(window.location.search);
            const redirectPath = params.get('redirect') || '/customer/account';
            navigate(redirectPath);
        } catch (error) {
            toast.error(error.response?.data?.error || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#FDFDFD] flex flex-col font-sans animate-fade-in">
            <Header />

            <div className="flex-1 flex items-center justify-center p-4 mt-20">
                <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100">
                    <div className="text-center mb-8">
                        <h1 className="text-2xl font-bold text-slate-900">Sign In</h1>
                        <p className="text-slate-500 mt-2">Access your eDisplayroom account</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="space-y-2">
                            <Label>Email Address</Label>
                            <Input
                                type="email"
                                value={formData.email}
                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                required
                                className="h-11 rounded-xl"
                            />
                        </div>
                        <div className="space-y-2">
                            <div className="flex items-center justify-between">
                                <Label>Password</Label>
                                <Link to="/customer/forgot-password" className="text-sm font-medium text-amber-700 hover:underline">
                                    Forgot password?
                                </Link>
                            </div>
                            <Input
                                type="password"
                                value={formData.password}
                                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                required
                                className="h-11 rounded-xl"
                            />
                        </div>

                        <Button
                            type="submit"
                            disabled={loading}
                            className="w-full h-11 rounded-xl font-bold bg-amber-700 hover:bg-amber-800 text-white"
                        >
                            {loading ? 'Signing In...' : 'Sign In'}
                        </Button>
                    </form>

                    <p className="text-center mt-6 text-sm text-slate-500">
                        Don't have an account?{' '}
                        <Link to="/customer/register" className="font-bold text-amber-700 hover:underline">
                            Create one
                        </Link>
                    </p>
                </div>
            </div>

            <Footer />
        </div>
    );
}
